<template>
  <div class="page-landing" v-scroll-spy="scrollPos">

    <div class="hero is-primary section-main" id="section-main">
      <div class="hero-cover">
      </div>
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column is-8 is-offset-2">
              <p style="color:black;">
                <fb-login v-if="false" />
              </p>
            </div>
          </div>
          <div class="columns">
            <div class="column is-8 is-offset-2">
              <p class="title capital has-text-centered" data-aos="fade-up" data-aos-once="true">
                Let's Build<br />
                Something <span class="color-blue">Great</span>
                <br />
                <br />
                <img src="../assets/logo2.svg" width="240px" class="img-responsive" data-pin-nopin="true" />
                <br />
                <div>
                  <div style="display:flex;max-width:200px;margin:auto;" class="title" data-aos="fade-in" data-aos-once="true" data-aos-delay="500">
                    <span class="typewriter-start typewriter">
                      <div>
                        <a href="#" class="page-scroll" @click="$event.preventDefault();$scrollTo('#section-main-showcase', { offset: 80 })" style="cursor:pointer;"><span class="color-red">$</span> <span class="color-orange">: _</span>&nbsp;&nbsp;<span class="" style="width:100%;margin-right:10px;margin-bottom:1em;">HERE</span>&nbsp;</a>
                      </div>
                    </span>
                  </div>
                </div>
                <br />
                <br />
                <br />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div style="position:relative;z-index:1;">
      <a class="next-section next-gray" rel="nofollow" href="#portfolio" @click="$event.preventDefault();$scrollTo('#section-showcase')">
        <i class="material-icons" style="font-size:1.5em;">keyboard_arrow_down</i>
      </a>
    </div> -->

    <div class="hero is-primary section-main section-main-reversed" id="section-main-2">
      <div class="hero-cover hero-cover-reversed">
      </div>
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column is-8 is-offset-2">
              <p class="title capital" data-aos="fade-up" data-aos-once="true">
                <br />
                <br />
                <br />
                <br />
                <span class="color-red">Cast</span> a <span class="color-orange">reflection</span> :<br />
                of your<br />
                <div style="display:flex;" class="title">
                  <span class="typewriter-start typewriter">
                    <div>
                      <a href="#" class="page-scroll" @click="$event.preventDefault();$scrollTo('#section-main-3', { offset: -50 })" style="cursor:pointer;"><span class="color-orange">_</span> thought <span class="color-red">_</span>&nbsp;&nbsp;</a>
                    </div>
                  </span>
                </div>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <!--<img src="../assets/brain.svg" width="200px" class="img-responsive" data-aos="fade-right" data-aos-once="true" data-pin-nopin="true" /><br />-->
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="hero is-primary section-main section-main-highlighted" id="section-main-3" v-if="false">
      <div class="hero-cover hero-cover-highlighted">
      </div>
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column is-8 is-offset-2">
              <p class="title capital" data-aos="fade-up" data-aos-once="true">
                Succumb to <span class="color-blue">..</span> <span style="color:#A01A37;">chaos</span><br />
                or <br />
                <br />
                <img src="../assets/chaos-graph.gif" width="300px" class="img-responsive" data-aos="fade-right" data-aos-once="true" data-pin-nopin="true" /><br />
                <div style="display:flex;" class="title">
                  <span class="typewriter-start typewriter">
                    <div>
                      <a href="#" class="page-scroll" @click="$event.preventDefault();$scrollTo('#section-main-4', { offset: -50 })" style="cursor:pointer;"><span class="color-blue"><i class="fa fa-check"></i></span> re-order <span class="color-orange">/</span> <span class="color-blue">_</span> &nbsp;</a>
                    </div>
                  </span>
                </div>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <content-project-list-section id="section-main-showcase" v-if="false"></content-project-list-section>

    <content-service-list-section v-if="false"></content-service-list-section>

    <top-section v-if="false"></top-section>

    <div class="hero is-primary section-main section-main-ads" id="section-main-5">
      <div class="hero-cover hero-cover-ads">
      </div>
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column is-8 is-offset-2 has-text-centered" data-aos="fade-up" data-aos-once="true">
              <img src="../assets/ads.jpg" style="margin-bottom:1rem;" />
              <div>
                <span>&quot;we'll be right back after this commercial break.&quot;</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <content-project-list-section v-if="false"></content-project-list-section>

    <content-quote-section v-if="false"></content-quote-section>

    <section-comment v-if="false"></section-comment>

  </div>
</template>

<script>
  import EventBus from '@/controllers/EventBus'
  import FBControl from '@/controllers/FBControl'
  import FbLogin from '@/components/FBLogin'

  import TopSection from '@/components/TopSection'
  import ContentServiceListSection from '@/components/ContentServiceListSection'
  import ContentProjectListSection from '@/components/ContentProjectListSection'
  import ContentQuoteSection from '@/components/ContentQuoteSection'
  export default {
    name: 'landing',
    metaInfo: {
      title: 'home'
    },
    components: {
      FbLogin,
      TopSection,
      ContentServiceListSection,
      ContentProjectListSection,
      ContentQuoteSection
    },
    data () {
      return {
        scrollPos: 0,
        quoteContent: ''
      }
    },
    computed: {
      quoteContentUrl: function () {
        return 'https://twitter.com/intent/tweet?text=' + encodeURI(this.quoteContent)
      }
    },
    watch: {
      scrollPos: function (val) {
        EventBus.$emit('scroll-pos-change', { name: 'landing', scrollPos: val })
      }
    },
    created () {
    },
    mounted () {
      FBControl.logPageView()
      FBControl.logEvent('debugNoctorus')

      if (this.$route.query && this.$route.query.anchor) {
        setTimeout(function () {
          this.$scrollTo('#' + this.$route.query.anchor)
        }.bind(this), 1000)
      }

      // window.GA('send', 'pageview')
    },
    methods: {
      onScrollTo: function (name) {
        this.$scrollTo('#' + name)
      }.bind(this)
    }
  }
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-landing {
  min-height: 100%;
  position: relative;
  font-size: 0.9em;

  .hero.is-primary .title {
    color: $color-gray-mid;
    // font-family: $font-family-title;
  }

  .title {
    margin: 30px;

    &.capital {
      font-size: 2.5rem;
      font-weight: bold;
      text-transform: uppercase;
    }

    span {
      font-size: 2.5rem;
      font-weight: bold;
    }
  }

  ul li {
    a {
      margin-left: 5px;
    }

    i.fa {
      vertical-align: middle;
      margin-left: 5px;
    }
  }
}

.particle-wrapper {
   position: relative;
   width: 100%;
   height: 100%;
   overflow: hidden;

   .particle-main {
     position: absolute;
     width: 100%;
     height: 100%;

     canvas {
       min-height: 200vh;
     }
   }
}

.next-gray {
  background-color: $color-gray-mid;
  color: #1c1e26;
}

.section-main {
  overflow: visible;
  position: relative;

  .hero-cover {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0%;
    background-color: $color-main;
    background-position: bottom right;
    background-repeat: no-repeat;
    background-image: url(../assets/pattern01.png);
    -moz-box-shadow:    inset  0 -10px 10px -10px $color-black-alt;
    -webkit-box-shadow: inset  0 -10px 10px -10px $color-black-alt;
    box-shadow:        inset   0 -10px 10px -10px $color-black-alt;

    &.hero-cover-reversed {
      background-color: $color-blue;
      top: 0%;
      transform: scaleY(-1);
      filter: FlipH;
    }

    &.hero-cover-highlighted {
      background-image: none;
      background-color: $color-red;
      top:0%;
    }

    &.hero-cover-ads {
      background-image: none;
      background-color: #110a1a;
      top:0%;
      transform: scaleY(-1);
      filter: FlipH;
    }

    background-size: 350px;

    @media screen and (min-width: $tablet) {
      background-size: 500px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// Landing.vue?49f8f304